interface Images {
  [x: string]: string;
}

const images: Images = {
  appmtrix: 'appmtrix.png',
  basketmix: 'basketmix.jpg',
  captare: 'captare.png',
  censor: 'censor.png',
  dashboard: 'dashboard.png',
  highlights: 'highlights.png',
  impackt: 'impackt.png',
  interaction: 'interaction.png',
  mind: 'mind.png',
  stockview: 'stockview.png',
  temla: 'temla.png',
  mtrix: 'mtrix.jpeg',
};

export const getPalavras = (value: string) => {
  const title = value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase();

  switch (true) {
    case Boolean(title.match(/implanta|implantação|implantacao/)?.length):
      return 'mtrix';

    case Boolean(title.match(/appmtrix|app mtrix|app/)?.length):
      return 'appmtrix';

    case Boolean(title.match(/basketmix|basket mix/)?.length):
      return 'basketmix';

    case Boolean(title.match(/captare/)?.length):
      return 'captare';

    case Boolean(title.match(/censor/)?.length):
      return 'censor';

    case Boolean(title.match(/se|dashboard/)?.length):
      return 'dashboard';

    case Boolean(title.match(/highlights/)?.length):
      return 'highlights';

    case Boolean(title.match(/impackt/)?.length):
      return 'impackt';

    case Boolean(title.match(/interaction|inter action/)?.length):
      return 'interaction';

    case Boolean(title.match(/mind/)?.length):
      return 'mind';

    case Boolean(title.match(/stockview|stock view/)?.length):
      return 'stockview';

    case Boolean(title.match(/temla|tem la/)?.length):
      return 'temla';

    default:
      return 'mtrix';
  }
};

const getImage = (title: string) => images[getPalavras(title)];

export default getImage;
